"use client";

import { Link } from "@/components/LocaleLink";
import { Logo } from "@/components/Logo";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { useAuthStore } from "@/lib/store";

export function BlogHeader() {
  const { isAuthenticated, _hasHydrated } = useAuthStore();

  return (
    <header className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <Link href="/" className="flex items-center gap-2">
          <Logo size="sm" />
        </Link>
        <nav className="flex items-center gap-4">
          <Link
            href="/blog"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Blog
          </Link>
          <Link
            href="/pricing"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Tarifs
          </Link>
          <LanguageSwitcher />
          {_hasHydrated && isAuthenticated ? (
            <Link href="/dashboard">
              <button className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors">
                Dashboard
              </button>
            </Link>
          ) : (
            <Link href="/login">
              <button className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors">
                Connexion
              </button>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
